import Alpine from 'alpinejs'

Alpine.data('jobDialogData', () => ({
  closed: !!localStorage.getItem('job_dialog'),
  init() {
    this.$watch('closed', () => {
      localStorage.setItem('job_dialog', 'true')
    });
  },
  showJobDialog() {
    if(this.closed) {
      return;
    }

    (document.getElementById('job-dialog') as HTMLDialogElement).showModal();
  },
  closeJobDialog() {
    (document.getElementById('job-dialog') as HTMLDialogElement).close();
    this.closed = true;
  }
}));
